import { useState } from "react";
import "./App.css";
import Accomodation from "./components/Accomodation";
import AccomodationGR from "./components/AccomodationGR";
import AlMareHotel from "./components/AlMareHotel";
import AlMareHotelGR from "./components/AlMareHotelGR";
import ContactUs from "./components/ContactUs";
import ContactUsGR from "./components/ContactUsGR";
import Contents from "./components/Contents";
import ContentsGR from "./components/ContentsGR";
import Footer from "./components/Footer";
import FooterGR from "./components/FooterGR";
import Gallery from "./components/Gallery";
import GalleryGR from "./components/GalleryGR";
import Header from "./components/Header";
import HeaderGR from "./components/HeaderGR";
import Prices from "./components/Prices";
import PricesGR from "./components/PricesGR";

function App() {
  const [toggleLanguage, setToggleLanguage] = useState<boolean>(true);
  return (
    <div className="App">
      {toggleLanguage ? (
        <>
          <Header
            setToggleLanguage={setToggleLanguage}
            toggleLanguage={toggleLanguage}
          />
          <AlMareHotel />
          <Accomodation />
          <Gallery />
          <Contents />
          <Prices />
          <ContactUs />
          <Footer />
        </>
      ) : (
        <>
          <HeaderGR
            setToggleLanguage={setToggleLanguage}
            toggleLanguage={toggleLanguage}
          />
          <AlMareHotelGR />
          <AccomodationGR />
          <GalleryGR />
          <ContentsGR />
          <PricesGR />
          <ContactUsGR />
          <FooterGR />
        </>
      )}
    </div>
  );
}

export default App;
